<template lang="pug">
.vue-container
    .title
        .content
            h1 {{article.title}}
            .info.clearfix
                .useinfo
                    img.img-response(:src="addOn.authorAvatar" )
                    span.name {{article.username}}
                    span.vericon(v-if="uiArticleVerInfo!=''" :class="uiArticleVerInfo")
                    span.label
                span.compile(@click="editArticle" v-if="addOn.curUid == article.uid")
                span.time {{addOn.create_time}}
                span.normal.ml15
                    i.iconfont.re &#xe611;
                    em {{article.reply_num}}
                span.normal
                    i.iconfont &#xe613;
                    span {{article.see_num}}
    .content
        span.action(v-if="addOn.log.username") {{ addOn.log.username + '于' + addOn.log.create_time + '对帖子进行了' + addOn.log.content }}

        .wrap#js-article-content(v-html="helper.fixRichText(article._data2show.pcContent)"
        v-lazy-container="{ selector: '.preimg' }"
        )
        .ad-img(v-if="article.ad_img")
            img(:src="article.ad_img")
        span.warning(v-if="article.group_id==25") 二手交易有风险，买卖双方交易需谨慎，小心资金财产损失！
        .bottom-btns
            .praise-wrap
                .praise(@click="praise('article')" :class="data.isPraise==1?'done':''")
                    i.iconfont &#xe616;
                    .text {{data.isPraise==1?'已点赞':'点赞'}}
                    .number {{data.praiseNum}}
            .shared(v-if="data.praiseList.length >0 ")
                .t 这些小伙伴都在分享
                ul.clearfix
                    li(v-for="(item,key) in data.praiseList" v-if="key < 37")
                        img(:src="item")
                    li.more(v-if="data.praiseList.length > 37")
                        span
                        span
                        span
            div(style="margin:20px 0px" )
            .house
                .t 快来分享吧
                .con
                    .collet(:class="data.isHouse ==1 ? 'done' : '' " @click="articleHouse")
                        i.iconfont &#xe612
                        font {{ data.isHouse == 1 ? '已收藏' : '收藏' }}
                    .bdsharebuttonbox
    .ad-box(style="margin-bottom:15px" v-html="adData[1125]")

    .comment#comment
        .reply-box
            .commentInput
                textarea.textarea(contenteditable="true" id="replyContent" placeholder="随便说两句吧...")
            div
            .reply-bottom.clearfix
                .btn(@click="articleReply" :class="uiReplyButtonDisable == true ? 'disable' : ''") 跟帖
                .reply-link(@click="openReply") 高级评论模式
                .reply-select
                     .pager(@click="popupPager('userlist', $event)")
                         .pager-show
                             span 切换账号
                         .pager-list.text-overflow(v-if="showPagerUserList")
                             span.list.op-item(v-for="item in data.userList" @click="adminClick(item)") {{item.username}}
            .reply-select
                .pager
                    .pager-show(@click="showAdmin")
        .comment-head.clearfix
            h3 跟帖已盖
                em {{uiTotalReplies+'楼'}}
            .pager(@click="popupPager('page', $event)")
                .pager-show
                    span {{replyPage + '/' + totalPage}}
                .pager-list.text-overflow(v-if="showPager")
                    span.op-item(v-for="p in pageList" @click="loadReply(p)") {{'第'+p+'页'}}
            .pager.mr15(@click="popupPager('sort' , $event )")
                .pager-show
                     span {{orderMode == 'asc' ? '回复顺序' : '回复倒叙'}}
                .pager-list.text-overflow(v-if="showPagerSort")
                     span.op-item(@click="setOrderMode('asc')") 回复顺序
                     span.op-item(@click="setOrderMode('desc')") 回复倒叙
        .rub(v-if="uiShowLoadComment")
            .loading.bottom
                i.icon
                span 加载中...
        ul.list
            li.floor( v-for="(item,replyKey) in replyList")
                .author
                    .wrap.clearfix
                        .avatar
                            img(:src="item.user_image")
                        .info
                            span.name(:class="item.isVip == 1 ? 'vip' : '' ") {{item.contactname}}
                            span.verinfo
                            span.f {{item.floor_math+'楼'}}
                            em 于
                            font.time {{item.date}}
                        .r
                            span.rep(v-if="data.isAdmin" @click="manageEdit(item)") 修改
                            span.rep(v-if="data.isAdmin" @click="manageDelete(item)")  删除
                            span.rep(@click="replyPost(replyKey,item)")  回复
                            span.like(@click="praise('reply',item.id,replyKey)" :class="item.position.state == 2 ? 'done' : '' ")
                                i.iconfont &#xe616;
                                font {{item.position.count}}
                .reply-comment.clearfix(v-if="item.uiShowReplyBox===true")
                    .reply-box
                        .commentInput
                            textarea.textarea(contenteditable="true" :id="'replyContent'+item.id")
                        .reply-bottom
                            .btn(@click="articleReply(item)") 发布评论
                            .btn.cancelReply(@click="item.uiShowReplyBox=false") 取消
                            .reply-link(@click="openReply(item)") 高级评论模式
                .cont.clearfix(:data="'dsaasdfll'+item.uiShowReplyBox")
                    span.f
                    .c
                        .rcont(v-html="item.message")
                        .rcont-img(v-if="item.image.length>0")
                            .img-item(v-for="commentImg in item.image")
                                a(:href="commentImg.mall" target="_blank")
                                    img(:src="commentImg.mall")
                        .child-comment(v-if="item.childComment.length > 0")
                            .c-comment(v-for="(cReply,floorKey) in item.childComment")
                                .cm-uinfo
                                    span.username {{cReply.contactname}}
                                    span.floor {{(floorKey+1)+'楼'}}
                                    span.date {{cReply.date}}

                                    span.manage-area(v-if="data.isAdmin")
                                        span(@click="manageDelete(cReply)") 删除
                                .cm-content(v-html="cReply.message")
                            .c-viewmore(v-if="item.replycount>3 && !item.loadedChildren")
                                em(@click="viewMore(replyKey,item.id)") 查看全部评论
            .pagination
                span(@click="loadReply('prev')") 上一页
                span(@click="loadReply('next')") 下一页
    .fix-toolbar
        .manage(style="bottom:106px" v-if="data.isAdmin" @click="switchMark")
            .text {{uiTextMark}}
        .manage( v-if="data.isAdmin" @click="showPopup=true")
            .text 管理
        .toTop(@click="scrollTop" v-if="uiShowGoToTop")
            i.iconfont &#xe617;
            .text 顶部
    Popup(v-if="showPopup" :data="data" popType='manage' :popData="{article:article}"
        @operationEvent="operation" )

</template>

<info>
    <div class="rub">
        <div class="loading bottom"
             ms-visible="@loadBottomDisplay"
             ms-html="@loadBottomHTML">
        </div>
    </div><i class='icon'></i><span>正在加载中...</span>
</info>

<style lang="scss">

</style>
<script>
    import globalMixin from "../mixin/global";
    import helper from "../lib/articleHelper";
    import Popup from "../components/Popup.vue"
    import utils from "../lib/util";
    import $ from "jquery";
    export default {
        name: 'ContentView',
        mixins: [globalMixin],

        components : {
            Popup
        },
        data : function(){
            return {
                article : window.server.article,
                addOn : window.server.addOn,
                data : window.server.data,
                helper : helper,

                adData : window.bzAdMerge,


                uiTotalReplies : 0,

                replyList : [],
                replyPage : 1,
                totalPage : null,
                pageList : [],
                orderMode : "asc",

                showPager : false,
                showPagerSort :false,

                loginUrl : "/site/login.html",

                uiShowGoToTop : false,
                uiTextMark : '加水印',
                uiArticleVerInfo : "",
                uiShowLoadComment : false ,

                uiReplyButtonDisable : false,
                showPagerUserList : false,

                showPopup : false,

            }
        },
        beforeMount(){

            let mThis = this;
            this.loadReply(1);

            //右上角登录状态
            if (window.server.addOn.curUid != '0'){
                $('#head-personal .pop').css({
                    top : "100%"
                })
            }
            console.log(this.data);

            helper.bodyScrollBottom(function(){

            },function(top){
                if (top >= 600){
                    mThis.uiShowGoToTop = true;

                } else {
                    mThis.uiShowGoToTop = false;
                }

                //recommend box
                if (top >= 265 ){
                    $('.recommend').css({
                        top : '0px'
                    });
                } else {
                    $('.recommend').css({
                        top : '265px'
                    });
                }
            });
            //水印 状态
            this.uiTextMark = location.href.indexOf('nomark=1') > -1 ? "加水印" : "去水印";

            //贴住 认证信息
            if (window.server.data.authorInfo.zmtType > 0){
                this.uiArticleVerInfo += " ver" + window.server.data.authorInfo.zmtType;
            }
            if (window.server.data.is_vip != '0'){
                this.uiArticleVerInfo += 'vip';
            }
        },

        methods : {

            //pop
            /**
             * @param {{display:bool , event : event}} childObject
             **/
            operation : function(childObject){

                if (childObject.event == undefined ||
                    $(childObject.event.target).hasClass('van-popup') ){
                    this.showPopup = childObject.display;
                }
            },
            //pop end


            setOrderMode : function(m){
                this.orderMode = m;
                this.showPagerSort = false;
                console.log(this.showPagerSort);
                this.loadReply(1);
            },
            praise : function(type,id , replyKey ){
                if (window.server.addOn.curUid == '') {
                    location.href= this.loginUrl;
                    return;
                }
                let mThis = this;
                let reqId= window.server.article.id;
                if (type == 'reply'){
                    reqId = id;
                }


                $.getJSON("/article/praise.html?id=" + reqId + "&type=" + type , function(){

                    if (type == 'article'){

                        if (mThis.data.isPraise == 1){
                            mThis.data.isPraise = 0;
                            mThis.data.praiseNum --;
                            if (mThis.data.praiseNum <0){
                                mThis.data.praiseNum = 0;
                            }
                        } else {
                            mThis.data.isPraise = 1;
                            mThis.data.praiseNum ++;
                        }
                        //mThis.data.
                    } else {
                        //mThis.loadReply(mThis.replyPage);
                        let old = mThis.replyList[replyKey];
                        if (old.position.state == 2){
                            old.position.count --;
                            old.position.state = 1;
                        } else {
                            old.position.count ++;
                            old.position.state = 2;
                        }

                        mThis.replyList[replyKey] = old;
                    }

                });
            },
            scrollTop : function(){
                window.scrollTo(0,0);
            },
            articleHouse : function(){
                if (window.server.addOn.curUid == '') {
                    location.href= this.loginUrl;
                    return;
                }
                let mThis = this;
                $.getJSON("/article/house.html?id=" + window.server.article.id , function(){
                    mThis.data.isHouse = 1;
                });

            },
            //水印切换
            switchMark : function(){
                let url = location.href
                if (location.href.indexOf('nomark=1') > -1){
                    location.href = this.addOn.baseUrl;
                } else {
                    location.href = this.addOn.baseUrl + "&nomark=1";
                }
            },
            popupPager : function(type , event){

                //console.log(  );
                let isChild = $(event.target).hasClass('op-item');
                let showOptions = true;
                if ( isChild ){
                    showOptions = false;
                }

                if (type == 'page'){
                    this.showPager = showOptions;
                } else if (type == 'sort' ){
                    this.showPagerSort = showOptions;
                } else if (type == 'userlist'){
                    this.showPagerUserList = showOptions;
                }

            },

            fixReply : function( replyList ){
                let ret = [];
                for(var x in replyList){

                    let item = replyList[x];
                    item.uiShowReplyBox = false;
                    ret[x] = item;
                }
                return ret;
            },

            editArticle : function(){
                location.href = "/article/update.html?id=" + this.article.id ;
            },

            loadReply : function( page ){

                if ( page == 'prev' ){
                    this.replyPage --;
                } else if ( page == 'next'){
                    this.replyPage ++;
                } else {
                    this.replyPage = page;
                }


                if (this.replyPage <= 1){
                    this.replyPage = 1;
                } else if( this.totalPage != null && this.replyPage > this.totalPage){
                    this.replyPage = this.totalPage;
                }
                console.log(this.replyPage);

                this.showPager = false;

                let apiUrl = `/reply/reply-list.html?articleId=${this.article.id}&page=${this.replyPage}&orderType=${this.orderMode}`;
                let mThis = this;

                this.uiShowLoadComment = true;

                mThis.replyList = [];

                $.getJSON(apiUrl , function(data){

                    mThis.uiShowLoadComment = false;

                    if (data.type != 'succ'){
                        alert(data.msg);return;
                    }
                    mThis.replyList = mThis.fixReply(data.msg.list);
                    mThis.totalPage = data.msg.page.pagetotal;
                    mThis.uiTotalReplies = data.msg.page.total;
                    if (mThis.totalPage > 0){
                        mThis.pageList = [];
                        for(var x= 1;x<=mThis.totalPage; x++){
                            mThis.pageList.push(x);
                        }
                    }
                });
            },

            showAdmin : function(){},

            // 评论回复
            openReply: function(el) {
                if (el.id) {
                    location.href = "/article/create.html?articleId=" + this.article.id + "&replyId=" + el.id
                } else {
                    location.href = "/article/create.html?articleId=" + this.article.id
                }
            },

            adminClick : function(item){
                $.getJSON(this.data.adminUserLoginUrl + "?uid=" + item.uid,function(response){
                    if (response.type == "succ") {
                        alert('切换账号成功！');
                        window.location.reload();
                    } else {
                        alert("切换账号失败");
                    }
                });
            },
            manageEdit : function(el){
                location.href = this.data.updateReplyUrl + "?id=" + el.id
            },
            manageDelete : function(el){

                if (!confirm('"确认删除这条评论"')){
                    return ;
                }

                $.getJSON(window.server.data.replyDeleteUrl + `&id=${el.id}&uid=${el.uid}&username=${el.username}`,function(response){

                    if (response.type == "succ") {
                        alert("删除成功");
                        window.location.reload();
                    } else {
                        alert("删除失败");
                    }

                });
            },
            // 回复仅自己可见的操作
            seeReply: function(el) {
                var viewAccess;
                if (el.view_access == 0) {
                    viewAccess = 1;
                } else {
                    viewAccess = 0;
                }
                ajax.getWithFail(
                    window.server.articleBase.replyViewUrl +
                    "?id=" +
                    el.id +
                    "&type=" +
                    viewAccess
                );
                _load(1, "asc");
            },
            // 由于avalon2.的BUG 使用v-model在ie中会报错  只能用jquery获取文本域的值
            articleReply : function(el) {

                if (window.server.addOn.curUid == '') {
                    location.href= this.loginUrl;
                    return;
                }

                if ( this.uiReplyButtonDisable == true ){
                    return ;
                }

                this.uiReplyButtonDisable = true;
                // 判断内容不能为空

                var replyContentName , mThis = this;
                if (el.id) {
                    replyContentName = "replyContent" + el.id;
                } else {
                    replyContentName = "replyContent";
                }
                var replyContent = $("#" + replyContentName).val();
                // if($.trim(replyContent.replace(/\r\n/g,'')).length == 0){
                // 	return dialog.alert('抱歉，回复内容不能为空！');
                // }
                localStorage[replyContentName] = replyContent;

                $.post(this.data.replyArticleUrl , {
                    article_id: window.server.article.id,
                    content: replyContent,
                    parent_reply_id: el.id || 0,
                    format: 1
                } , function( response ){

                    localStorage[replyContentName] = "";
                    $("#" + replyContentName).val("");
                    mThis.uiReplyButtonDisable = false;
                    mThis.loadReply(1);
                } , 'JSON');

                var kit = this;

            },

            viewMore : function( arrKey , pId ){
                ///reply/child-reply.html
                let apiUrl = `/reply/child-reply.html?parentid=${pId}`;
                let mThis = this;
                $.getJSON(apiUrl , function( response ){
                    if (response.type != 'succ'){
                        alert(response.msg);
                        return;
                    }
                    mThis.replyList[arrKey].loadedChildren = true;
                    mThis.replyList[arrKey].childComment = response.msg;
                });
            },
            replyPost : function(arrKey , item){

                this.replyList[arrKey].uiShowReplyBox = !this.replyList[arrKey].uiShowReplyBox;
                this.replyList = this.replyList;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/ContentView.vue